var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.result
      ? _c("section", [
          _c("div", { staticClass: "container-fluid" }, [
            _c("div", { staticClass: "row" }, [
              _vm.loading
                ? _c("div", { staticClass: "col-md-12 text-center" }, [
                    _c("img", {
                      attrs: {
                        src: "/images/loading.svg",
                        width: "50",
                        alt: "Loading"
                      }
                    })
                  ])
                : _c("div", { staticClass: "col-md-12" }, [
                    _vm._v(
                      "\n                    Vehicle not found.\n                "
                    )
                  ])
            ])
          ])
        ])
      : _c(
          "section",
          { attrs: { id: "single-vehicle-page" } },
          [
            _c(
              "div",
              { staticClass: "container-fluid grey container-fluid-wide" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "container-fluid" }, [
                      _vm.currentNextPrev
                        ? _c("div", { staticClass: "next-prev" }, [
                            _c(
                              "a",
                              {
                                staticClass: "prev",
                                attrs: { href: "#!" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.handleVehicleNextPrev(false)
                                  }
                                }
                              },
                              [_vm._v("Prev")]
                            ),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.vehicleNextPrevCounterText))
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "next",
                                attrs: { href: "#!" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.handleVehicleNextPrev(true)
                                  }
                                }
                              },
                              [_vm._v("Next")]
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { id: "bid-now" } },
                      [
                        _c("div", { staticClass: "left" }, [
                          _c("div", { staticClass: "model-title" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.result.year) +
                                "\n                                " +
                                _vm._s(_vm.result.make) +
                                "\n                                " +
                                _vm._s(_vm.result.model) +
                                "\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.$userCan("fav_list")
                            ? _c(
                                "div",
                                {
                                  staticClass: "favourite",
                                  on: {
                                    click: function($event) {
                                      _vm.favListModalOpen = true
                                    }
                                  }
                                },
                                [_c("span", [_vm._v("Add to list")])]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentNextPrev && _vm.currentNextPrev.back_to_all
                            ? _c(
                                "a",
                                {
                                  staticClass: "link back",
                                  attrs: {
                                    href: _vm.currentNextPrev.back_to_all
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                Back to all\n                            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.showBidBox
                          ? [
                              _c("div", { staticClass: "current-bid" }, [
                                _c("div", { attrs: { id: "bid-notes" } }, [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-11" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c(
                                          "label",
                                          { attrs: { for: "bid-notes" } },
                                          [
                                            _vm._v(
                                              "\n                                                    Bid Notes\n                                                    "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "cursor-pointer",
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.addToBidNote(
                                                      "&#x1F6AD"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("🚭")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.bidNote,
                                              expression: "bidNote"
                                            }
                                          ],
                                          attrs: {
                                            type: "text",
                                            id: "bidNote",
                                            name: "bidNote",
                                            placeholder: "Bid Notes",
                                            value: ""
                                          },
                                          domProps: { value: _vm.bidNote },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.bidNote = $event.target.value
                                            }
                                          }
                                        })
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "place-bid" }, [
                                _c("div", { staticClass: "item-place-bid" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-place-bid" },
                                    [
                                      _vm._v(
                                        "\n                                        Estimated Landed Cost\n                                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-group inline-label" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          attrs: { for: "estimatedLandedCost" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            Bid\n                                            " +
                                              _vm._s(_vm.user_currency_code) +
                                              "\n                                            " +
                                              _vm._s(_vm.user_currency_sign) +
                                              "\n                                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.estimatedLandedCost,
                                            expression: "estimatedLandedCost"
                                          }
                                        ],
                                        ref: "bidNzd",
                                        attrs: {
                                          type: "text",
                                          id: "estimatedLandedCost",
                                          name: "estimatedLandedCost",
                                          value: "",
                                          disabled: _vm.userHasBid
                                        },
                                        domProps: {
                                          value: _vm.estimatedLandedCost
                                        },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.estimatedLandedCost =
                                                $event.target.value
                                            },
                                            _vm.onLandedCostInput
                                          ],
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.onBidClick.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "item-place-bid" }, [
                                  _c(
                                    "div",
                                    { staticClass: "title-place-bid" },
                                    [
                                      _vm._v(
                                        "\n                                        Bid (thousands of yen)\n                                    "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group inline-label float-span"
                                    },
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "bidPrice" } },
                                        [_vm._v("Bid JPY ¥")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.bidPriceProxy,
                                            expression: "bidPriceProxy"
                                          }
                                        ],
                                        ref: "bidJpy",
                                        attrs: {
                                          type: "text",
                                          id: "bidPrice",
                                          name: "bidPrice",
                                          value: "",
                                          disabled: _vm.userHasBid
                                        },
                                        domProps: { value: _vm.bidPriceProxy },
                                        on: {
                                          input: [
                                            function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.bidPriceProxy =
                                                $event.target.value
                                            },
                                            _vm.onBidPriceInput
                                          ],
                                          keyup: function($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            return _vm.onBidClick.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "no-click" }, [
                                        _vm._v(",000")
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "item-place-bid suggested-range"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "title-place-bid" },
                                      [
                                        _vm.$userIsAdmin() &&
                                        _vm.result.market_research &&
                                        _vm.result.market_research.length
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                                            Suggested bid: "
                                              ),
                                              _c("br"),
                                              _vm._v(
                                                _vm._s(_vm.suggestedRange) +
                                                  "\n                                        "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn",
                                        attrs: { id: "bid-button" },
                                        on: { click: _vm.onBidClick }
                                      },
                                      [
                                        _vm.userHasBid
                                          ? [
                                              _vm._v(
                                                "\n                                            Change Bid\n                                        "
                                              )
                                            ]
                                          : [
                                              _vm._v(
                                                "\n                                            Place Bid :-)\n                                        "
                                              )
                                            ]
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-tooltip",
                                      {
                                        ref: "bidResultTooltip",
                                        attrs: {
                                          disabled: _vm.bidTooltipDisabled,
                                          target: "bid-button",
                                          triggers: "manual"
                                        },
                                        on: {
                                          "update:disabled": function($event) {
                                            _vm.bidTooltipDisabled = $event
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.bidResult) +
                                            "\n                                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(0)
                                  ],
                                  1
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { id: "bid-history" } }, [
                      _c("div", { staticClass: "table-responsive" }, [
                        _c("table", { staticClass: "bid-history table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("(+/-)")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Day")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Auc/Lot")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("ID")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Make")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Model/Grade")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Chassis")]),
                              _vm._v(" "),
                              _vm.$userIsAdmin()
                                ? _c("th", [_vm._v("CO2 (indication only)")])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("th", [_vm._v("Year")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Kms")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Colour")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("CC")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Trans")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("F")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Cnd")]),
                              _vm._v(" "),
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [_vm._v("Start")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Result")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tbody", [
                            _c(
                              "tr",
                              {
                                on: {
                                  contextmenu: function($event) {
                                    $event.preventDefault()
                                    return _vm.openFavList.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [
                                _c("td", { staticClass: "tag" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isFavourite,
                                        expression: "isFavourite"
                                      }
                                    ],
                                    attrs: {
                                      type: "checkbox",
                                      id: "tag",
                                      name: "checkbox-tag"
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.isFavourite)
                                        ? _vm._i(_vm.isFavourite, null) > -1
                                        : _vm.isFavourite
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = _vm.isFavourite,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isFavourite = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isFavourite = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isFavourite = $$c
                                          }
                                        },
                                        _vm.toggleFavourite
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("label", { attrs: { for: "tag" } }),
                                  _vm._v(" "),
                                  _c("small", [_vm._v("Tag")])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "date" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.getDate(_vm.result.auction_date)
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "yellow" }, [
                                  _c("div", [
                                    _vm._v(_vm._s(_vm.result.auction_house))
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [_vm._v(_vm._s(_vm.result.lot))])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "id-bid" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.api_id) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "make" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.make) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "model" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(_vm.result.model) +
                                        " /\n                                        "
                                    ),
                                    _vm.translatedFields["grade"]
                                      ? [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.translatedFields["grade"]
                                              )
                                            }
                                          })
                                        ]
                                      : [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.result.grade
                                              )
                                            }
                                          })
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.chassis) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.$userIsAdmin()
                                  ? _c("td", [
                                      _vm.result.co2_text
                                        ? _c(
                                            "div",
                                            {
                                              class:
                                                _vm.result.co2_text[0] === "-"
                                                  ? "text-danger"
                                                  : "text-success"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            " +
                                                  _vm._s(
                                                    _vm.result.co2_text.replace(
                                                      "-",
                                                      ""
                                                    )
                                                  ) +
                                                  "\n                                        "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.year) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.numberWithCommas(_vm.result.mileage)
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "color" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.color) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.engine_capacity) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.transmission) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.fuel_type) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.condition) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.equipment) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "blue" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.result.currency_sign) +
                                      " " +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          _vm.result.start_price / 1000
                                        )
                                      ) +
                                      "\n                                        k\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                !_vm.is_mobile
                                  ? _c(
                                      "td",
                                      {
                                        class:
                                          _vm.isSold() && !_vm.finalSoldPrice()
                                            ? "sold"
                                            : ""
                                      },
                                      [
                                        _c(
                                          "small",
                                          {
                                            attrs: {
                                              title: _vm.getJapanDiff(
                                                _vm.result.auction_date
                                              )
                                            }
                                          },
                                          [
                                            "00:00" ===
                                            _vm.getTime(
                                              _vm.result.auction_date,
                                              "HH:mm"
                                            )
                                              ? [
                                                  _vm._v(
                                                    "\n                                                Start time unknown\n                                            "
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.getTime(
                                                          _vm.result
                                                            .auction_date,
                                                          "h:mma"
                                                        )
                                                      ) +
                                                      " JPN /\n                                                " +
                                                      _vm._s(
                                                        _vm
                                                          .getNZDateTime(
                                                            _vm.result
                                                              .auction_date
                                                          )
                                                          .format("h:mma")
                                                      ) +
                                                      " NZ\n                                            "
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm.isSold()
                                          ? _c(
                                              "div",
                                              [
                                                _vm.result.bid_status ===
                                                "negotiation"
                                                  ? _c("span", [
                                                      _vm._v("Negotiation")
                                                    ])
                                                  : _vm.result.bid_status ===
                                                    "cancelled"
                                                  ? _c("span", [
                                                      _vm._v("Cancelled")
                                                    ])
                                                  : _vm.result.bid_status ===
                                                    "sold"
                                                  ? _c("span", [_vm._v("Sold")])
                                                  : _vm.result.bid_status ===
                                                    "processing"
                                                  ? _c("span")
                                                  : _vm.result.bid_status ===
                                                    "sold to sbl"
                                                  ? _c(
                                                      "span",
                                                      [
                                                        _vm.$userIsAdmin()
                                                          ? [
                                                              _vm._v(
                                                                "Sold to SBL"
                                                              )
                                                            ]
                                                          : [_vm._v("Sold")]
                                                      ],
                                                      2
                                                    )
                                                  : _c("span", [
                                                      _vm._v("Not sold")
                                                    ]),
                                                _vm._v(" "),
                                                _vm.result.end_price &&
                                                _vm.result.end_price > 0
                                                  ? [
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "blue",
                                                          attrs: {
                                                            title:
                                                              _vm.numberWithCommas(
                                                                _vm.result
                                                                  .end_price
                                                              ) + " yen"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    ¥ " +
                                                              _vm._s(
                                                                _vm.numberWithCommas(
                                                                  _vm.result
                                                                    .end_price /
                                                                    1000
                                                                )
                                                              ) +
                                                              " k\n                                                "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.is_mobile
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      class:
                                        _vm.isSold() && !_vm.finalSoldPrice()
                                          ? "sold"
                                          : "",
                                      attrs: { colspan: "14" }
                                    },
                                    [
                                      _c(
                                        "small",
                                        {
                                          attrs: {
                                            title: _vm.getJapanDiff(
                                              _vm.result.auction_date
                                            )
                                          }
                                        },
                                        [
                                          "00:00" ===
                                          _vm.getTime(
                                            _vm.result.auction_date,
                                            "HH:mm"
                                          )
                                            ? [
                                                _vm._v(
                                                  "\n                                                Start time unknown\n                                            "
                                                )
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(
                                                      _vm.getTime(
                                                        _vm.result.auction_date,
                                                        "h:mma"
                                                      )
                                                    ) +
                                                    " JPN /\n                                                " +
                                                    _vm._s(
                                                      _vm
                                                        .getNZDateTime(
                                                          _vm.result
                                                            .auction_date
                                                        )
                                                        .format("h:mma")
                                                    ) +
                                                    " NZ\n                                            "
                                                )
                                              ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm.isSold()
                                        ? _c(
                                            "div",
                                            [
                                              _vm.result.bid_status ===
                                              "negotiation"
                                                ? _c("span", [
                                                    _vm._v("Negotiation")
                                                  ])
                                                : _vm.result.bid_status ===
                                                  "cancelled"
                                                ? _c("span", [
                                                    _vm._v("Cancelled")
                                                  ])
                                                : _vm.result.bid_status ===
                                                  "sold"
                                                ? _c("span", [_vm._v("Sold")])
                                                : _vm.result.bid_status ===
                                                  "processing"
                                                ? _c("span")
                                                : _vm.result.bid_status ===
                                                  "sold to sbl"
                                                ? _c(
                                                    "span",
                                                    [
                                                      _vm.$userIsAdmin()
                                                        ? [
                                                            _vm._v(
                                                              "Sold to SBL"
                                                            )
                                                          ]
                                                        : [_vm._v("Sold")]
                                                    ],
                                                    2
                                                  )
                                                : _c("span", [
                                                    _vm._v("Not sold")
                                                  ]),
                                              _vm._v(" "),
                                              _vm.result.end_price &&
                                              _vm.result.end_price > 0
                                                ? [
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "blue",
                                                        attrs: {
                                                          title:
                                                            _vm.numberWithCommas(
                                                              _vm.result
                                                                .end_price
                                                            ) + " yen"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                    ¥ " +
                                                            _vm._s(
                                                              _vm.numberWithCommas(
                                                                _vm.result
                                                                  .end_price /
                                                                  1000
                                                              )
                                                            ) +
                                                            " k\n                                                "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "all-bid" },
                        [
                          _c("VehicleMessages", {
                            attrs: { vehicle: _vm.result }
                          }),
                          _vm._v(" "),
                          _vm.result.userBids && _vm.result.userBids.length
                            ? _vm._l(_vm.result.userBids, function(bid, index) {
                                return _c("div", [
                                  "bid_price_landed" in bid
                                    ? _c(
                                        "div",
                                        { staticClass: "bid" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "arrow item" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass: "collapsed",
                                                  attrs: {
                                                    type: "button",
                                                    "data-toggle": "collapse",
                                                    "data-target":
                                                      "#bid-messages-" + bid.id,
                                                    "aria-expanded":
                                                      "index === 0 ? 'true' : 'false'",
                                                    "aria-controls":
                                                      "#bid-messages-" + bid.id
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: require("../../images/collapse.svg"),
                                                      alt: "Collapse"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.is_mobile
                                            ? [
                                                _c(
                                                  "div",
                                                  { staticClass: "date item" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm.getDate(
                                                            bid.created_at
                                                          )
                                                        ) +
                                                        " " +
                                                        _vm._s(
                                                          _vm.getTime(
                                                            bid.created_at
                                                          )
                                                        ) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : [
                                                _c(
                                                  "div",
                                                  { staticClass: "date item" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm.getDate(
                                                            bid.created_at
                                                          )
                                                        ) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "hour item" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(
                                                          _vm.getTime(
                                                            bid.created_at
                                                          )
                                                        ) +
                                                        "\n                                            "
                                                    )
                                                  ]
                                                )
                                              ],
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "note item" },
                                            [
                                              _c("strong", [
                                                _vm._v(_vm._s(bid.note))
                                              ]),
                                              _vm._v(
                                                "\n                                            [SystemNote:\n                                            "
                                              ),
                                              [
                                                _vm._v(
                                                  _vm._s(bid.bid_by_name) + ";"
                                                )
                                              ],
                                              _vm._v(" "),
                                              [
                                                _vm._v(
                                                  "landed=" +
                                                    _vm._s(bid.currency_sign) +
                                                    _vm._s(
                                                      _vm.numberWithCommas(
                                                        bid.bid_price_landed
                                                      )
                                                    ) +
                                                    ";"
                                                )
                                              ],
                                              _vm._v(
                                                "\n                                            FX=" +
                                                  _vm._s(bid.exchange_rate) +
                                                  "]\n                                        "
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "item bid-details-container",
                                              style: _vm.bidColourStyle(bid)
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "who" },
                                                [
                                                  bid.user
                                                    ? [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "person",
                                                            attrs: {
                                                              href: _vm.$laravelRoute(
                                                                "users.show",
                                                                bid.user.id
                                                              )
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                bid.user.name
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        bid.user.company
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  bid.user
                                                                    .company
                                                                    .name
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.$userIsAdmin()
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "bump" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.bumpBidDisplay(
                                                                bid.bump_bid
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              bid.bid_price_jpy
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "bid-placed"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            bid.bump_bid &&
                                                            _vm.$userIsAdmin()
                                                              ? "strikeout"
                                                              : ""
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                    ¥ " +
                                                              _vm._s(
                                                                _vm.numberWithCommas(
                                                                  bid.bid_price_jpy
                                                                )
                                                              ) +
                                                              "\n                                                "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      bid.bump_bid &&
                                                      _vm.$userIsAdmin()
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "bid-total"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Cost ¥ " +
                                                                  _vm._s(
                                                                    _vm.numberWithCommas(
                                                                      bid.bid_price_jpy +
                                                                        bid.bump_bid
                                                                    )
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "tag" },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.bidFavourites[
                                                            bid.id
                                                          ],
                                                        expression:
                                                          "bidFavourites[bid.id]"
                                                      }
                                                    ],
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: "bidtag-" + bid.id
                                                    },
                                                    domProps: {
                                                      value: true,
                                                      checked: Array.isArray(
                                                        _vm.bidFavourites[
                                                          bid.id
                                                        ]
                                                      )
                                                        ? _vm._i(
                                                            _vm.bidFavourites[
                                                              bid.id
                                                            ],
                                                            true
                                                          ) > -1
                                                        : _vm.bidFavourites[
                                                            bid.id
                                                          ]
                                                    },
                                                    on: {
                                                      change: [
                                                        function($event) {
                                                          var $$a =
                                                              _vm.bidFavourites[
                                                                bid.id
                                                              ],
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = true,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  _vm.bidFavourites,
                                                                  bid.id,
                                                                  $$a.concat([
                                                                    $$v
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  _vm.bidFavourites,
                                                                  bid.id,
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              _vm.bidFavourites,
                                                              bid.id,
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                        function($event) {
                                                          return _vm.onBidFavChange(
                                                            bid.id
                                                          )
                                                        }
                                                      ]
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("label", {
                                                    attrs: {
                                                      for: "bidtag-" + bid.id
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              bid.remark
                                                ? _c(
                                                    "div",
                                                    { staticClass: "remark" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Remark")
                                                      ]),
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(bid.remark) +
                                                          "\n                                            "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showStatus(bid)
                                                ? _c(
                                                    "div",
                                                    {
                                                      class: [
                                                        "bid-status",
                                                        "bid-status-" +
                                                          bid.status_id
                                                      ]
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v("Status")
                                                      ]),
                                                      _vm._v(" "),
                                                      bid.status_id === 2
                                                        ? _c(
                                                            "span",
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Retry:\n                                                    " +
                                                                  _vm._s(
                                                                    bid.retry_count
                                                                  ) +
                                                                  " time"
                                                              ),
                                                              bid.retry_count >
                                                                1 ||
                                                              bid.retry_count ===
                                                                0
                                                                ? [_vm._v("s")]
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              bid.last_retried_at
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Last retry at " +
                                                                          _vm.getTime(
                                                                            bid.last_retried_at
                                                                          )
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                                                        | " +
                                                                          _vm._s(
                                                                            _vm.getTimeAgo(
                                                                              bid.last_retried_at
                                                                            )
                                                                          ) +
                                                                          "\n                                                    "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.nextRetryTime
                                                                  ) +
                                                                  "\n                                                    \n                                                "
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        : bid.status_id === 3
                                                        ? _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  "The bid failed, the vehicle is likely unavailable in Nichibo."
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    Failed - last retry at " +
                                                                  _vm._s(
                                                                    _vm.getTime(
                                                                      bid.last_retried_at
                                                                    )
                                                                  ) +
                                                                  "\n                                                "
                                                              )
                                                            ]
                                                          )
                                                        : bid.status_id === 4
                                                        ? _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  "The bid will be sent to Nichibo on auction day"
                                                              }
                                                            },
                                                            [_vm._v("Queued")]
                                                          )
                                                        : bid.status_id === 5 &&
                                                          _vm.$userIsSuperAdmin()
                                                        ? _c(
                                                            "span",
                                                            {
                                                              attrs: {
                                                                title:
                                                                  "This bid is on hold due to another bid beating it"
                                                              }
                                                            },
                                                            [_vm._v("Hold")]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        2
                                      )
                                    : bid.raw_note && bid.raw_note.length
                                    ? _c(
                                        "div",
                                        { staticClass: "bid bid-note-only" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "note item" },
                                            [
                                              _vm._v(
                                                "Bidder question: " +
                                                  _vm._s(bid.raw_note)
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  bid.messages
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "collapse show",
                                          attrs: {
                                            id: "bid-messages-" + bid.id
                                          }
                                        },
                                        [
                                          _vm._l(bid.messages, function(msg) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "bid history-bid",
                                                  class: _vm.messageClass(
                                                    msg,
                                                    bid
                                                  ),
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.selectMessage(
                                                        msg
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "date item"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.getDate(
                                                              msg.created_at
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "hour item"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.getTime(
                                                              msg.created_at
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "message-by item"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            msg.firstname
                                                          ) +
                                                          " " +
                                                          _vm._s(msg.lastname) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "note item"
                                                    },
                                                    [
                                                      _c("span", [
                                                        msg.rep_only
                                                          ? _c("strong", [
                                                              _vm._v("staff: ")
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              msg.message
                                                            ) +
                                                            "\n                                                    "
                                                        )
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  "bid_price_landed" in bid
                                    ? _c(
                                        "div",
                                        { staticClass: "history-buttons" },
                                        [
                                          _vm.$userIsAdmin()
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "link",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openTopBidModal(
                                                        bid
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Top Bid\n                                        "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "link add-message",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openMessageModal(
                                                    bid
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.$userIsAdmin()
                                                ? [_vm._v(" Client Message ")]
                                                : [_vm._v("Add Message")]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _vm.$userIsAdmin() &&
                                          _vm.result.is_moto
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "link add-message",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openStaffMessageModal(
                                                        bid
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            Moto Message\n                                        "
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$userIsAdmin()
                                            ? [
                                                bid.bid_price_jpy
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "link staff-message text-success",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addBidMessage(
                                                              bid.id,
                                                              _vm.keepBidMsg,
                                                              true
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Keep Bid\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          "bid_price_landed" in bid
                                            ? [
                                                _vm.$userIsAdmin() ||
                                                bid.user_id ===
                                                  _vm.loggedInUser.id
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "link staff-message",
                                                        attrs: {
                                                          disabled: !_vm.$canChangeBid(
                                                            bid,
                                                            _vm.result
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openChangeBidModal(
                                                              bid
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Change bid\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$userIsAdmin()
                                            ? [
                                                bid.bid_price_jpy
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "link staff-message text-danger",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.cancelBid(
                                                              bid.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                Cancel bid\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.$userIsAdmin()
                                            ? [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "link copy-stock float-right",
                                                    class: _vm.copiedToStock
                                                      ? "disabled"
                                                      : "",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.copyVehicleToStock(
                                                          _vm.result.api_id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                Copy to dealer stock\n                                            "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.result.message_images
                                                  ? [
                                                      bid.can_view_nichibo_images
                                                        ? [
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                attrs: {
                                                                  placement:
                                                                    "top",
                                                                  content:
                                                                    "They already have access to the images, to send the email again you can click this button"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    staticClass:
                                                                      "link disabled float-right",
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.onClickSendNichiboImages(
                                                                          bid
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            Send Nichibo Images "
                                                                    ),
                                                                    _c("icon", {
                                                                      attrs: {
                                                                        icon:
                                                                          "fa-picture-o",
                                                                        loading:
                                                                          _vm.loadingSendNichiboImages
                                                                      }
                                                                    })
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        : [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "link float-right",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.onClickSendNichiboImages(
                                                                      bid
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                        Send Nichibo Images "
                                                                ),
                                                                _c("icon", {
                                                                  attrs: {
                                                                    icon:
                                                                      "fa-picture-o",
                                                                    loading:
                                                                      _vm.loadingSendNichiboImages
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ]
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "float-right"
                                                  },
                                                  [_vm._v(" |      ")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "bids-icons-container"
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "col-sm-12 px-0 py-2 py-sm-0 d-block d-sm-inline"
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "cursor-pointer",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addBidMessage(
                                                                  bid.id,
                                                                  "&#x1F6AD",
                                                                  true
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [_vm._v("🚭")]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ])
                              })
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { attrs: { id: "description-vehicle" } }, [
                    _c(
                      "div",
                      { staticClass: "description-vehicle" },
                      [
                        _c(
                          "p",
                          [
                            _vm.result.ac || _vm.result.equipment
                              ? [
                                  _c("strong", [_vm._v("Equipment:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.result.ac) +
                                      " " +
                                      _vm._s(_vm.result.equipment) +
                                      "\n                                "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.$userIsAdmin() &&
                        _vm.result.userBids &&
                        _vm.result.userBids.length &&
                        _vm.result.userBids[0].buyers_at_auction &&
                        _vm.getSiteSetting("nichibo_sales_contacts")
                          ? [
                              _c("strong", [_vm._v("Buyers at auction ")]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.result.userBids[0].buyers_at_auction.split(
                                  ","
                                ),
                                function(buyer) {
                                  return [
                                    _c("br"),
                                    _vm._v(
                                      _vm._s(buyer) +
                                        "\n                                    "
                                    ),
                                    _vm._l(
                                      _vm.getSiteSetting(
                                        "nichibo_sales_contacts"
                                      ).contacts,
                                      function(contact) {
                                        return [
                                          contact.name === buyer
                                            ? _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href:
                                                      "tel:" +
                                                      contact.number.replaceAll(
                                                        " ",
                                                        ""
                                                      )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " tel: " +
                                                      _vm._s(contact.number)
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    )
                                  ]
                                }
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.translatedFields["description"]
                          ? [
                              _c("span", {
                                staticClass: "translated",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.translatedFields["description"]
                                  )
                                }
                              })
                            ]
                          : [
                              _c("span", {
                                staticClass: "not-translated",
                                domProps: {
                                  innerHTML: _vm._s(_vm.result.description)
                                }
                              })
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "info-tabs",
                        attrs: { id: "tabs-images" }
                      },
                      [
                        _c("div", { staticClass: "tab-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane fade-in active",
                              attrs: { role: "tabpanel", id: "images" }
                            },
                            [
                              _vm.result.images
                                ? _c(
                                    "div",
                                    { attrs: { id: "vehicle-image" } },
                                    [
                                      _c("VehicleImages", {
                                        attrs: {
                                          images: _vm.result.images,
                                          extra: _vm.result.images.extra
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane fade",
                              attrs: { role: "tabpanel", id: "avto-images" }
                            },
                            [
                              _vm.avtoImages
                                ? _c(
                                    "div",
                                    { attrs: { id: "avto-vehicle-image" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "container-image" },
                                        [
                                          _vm._l(_vm.imagesType, function(
                                            type
                                          ) {
                                            return [
                                              _vm.avtoImages[type]
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "three set-height",
                                                      attrs: {
                                                        href:
                                                          _vm.avtoImages[type][
                                                            "medium"
                                                          ],
                                                        "data-fancybox":
                                                          "gallery"
                                                      }
                                                    },
                                                    [
                                                      _c("div", {
                                                        staticClass: "magnifier"
                                                      }),
                                                      _vm._v(" "),
                                                      _c("img", {
                                                        attrs: {
                                                          src:
                                                            _vm.avtoImages[
                                                              type
                                                            ]["medium"],
                                                          alt:
                                                            _vm.result.model +
                                                            _vm.result.make +
                                                            type
                                                        }
                                                      })
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          }),
                                          _vm._v(" "),
                                          _vm.avtoImages.extra &&
                                          _vm.avtoImages.extra.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "two container-thumbnail"
                                                },
                                                _vm._l(
                                                  _vm.avtoImages.extra,
                                                  function(image, i) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "six set-height",
                                                        attrs: {
                                                          href: image["large"],
                                                          "data-fancybox":
                                                            "gallery"
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "magnifier"
                                                        }),
                                                        _vm._v(" "),
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              image["medium"],
                                                            alt:
                                                              _vm.result.model +
                                                              _vm.result.make +
                                                              i
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs",
                            attrs: { role: "tablist" }
                          },
                          [
                            _c("li", { staticClass: "active" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#images",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Primary\n                                    images(" +
                                      _vm._s(_vm.imagesCount) +
                                      ")"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", {}, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    "data-toggle": "tab",
                                    href: "#avto-images",
                                    role: "tab"
                                  }
                                },
                                [
                                  _vm._v(
                                    "Secondary\n                                    images(" +
                                      _vm._s(_vm.avtoImagesCount) +
                                      ")"
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "single-vehicle",
                        attrs: { id: "action-buttons" }
                      },
                      [
                        _vm.$userIsAdmin()
                          ? [
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function($event) {
                                      _vm.emailModalOpen = true
                                    }
                                  }
                                },
                                [_vm._v("Send Email")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function($event) {
                                      _vm.recommendModalOpen = true
                                    }
                                  }
                                },
                                [_vm._v("Send Recommend")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  attrs: {
                                    href: _vm.$laravelRoute("history.get", {
                                      vid: _vm.result.api_id
                                    }),
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("View Activity")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn",
                                  attrs: { disabled: _vm.copiedToStock },
                                  on: {
                                    click: function($event) {
                                      return _vm.copyVehicleToStock(
                                        _vm.result.api_id
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                    Copy to dealer stock\n                                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  attrs: {
                                    href: _vm.$laravelRoute("vehicle-csv", [
                                      _vm.result.api_id
                                    ]),
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("Spreadsheet")]
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn",
                            attrs: {
                              href: _vm.$laravelRoute("vehicle-pdf", [
                                _vm.result.api_id
                              ]),
                              target: "_blank"
                            }
                          },
                          [_vm._v("Print")]
                        ),
                        _vm._v(" "),
                        _vm.$userCan("fav_list")
                          ? _c(
                              "a",
                              {
                                staticClass: "btn",
                                attrs: { href: "#" },
                                on: { click: _vm.showFavouriteTags }
                              },
                              [
                                _vm._v(
                                  "Add to\n                                list"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "info-tabs info-single-vehicle",
                        attrs: { id: "tabs-vehicle" }
                      },
                      [
                        _c(
                          "ul",
                          {
                            staticClass: "nav nav-tabs",
                            attrs: { role: "tablist" }
                          },
                          [
                            _vm.result.market_research &&
                            _vm.result.market_research.length
                              ? [_vm._m(1), _vm._v(" "), _vm._m(2)]
                              : [_vm._m(3)],
                            _vm._v(" "),
                            _vm.result.co2_emissions && _vm.$userIsAdmin()
                              ? _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        "data-toggle": "tab",
                                        href: "#emissions",
                                        role: "tab"
                                      }
                                    },
                                    [_vm._v("Emissions")]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._m(4),
                            _vm._v(" "),
                            _vm._m(5)
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "tab-content" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tab-pane",
                              class:
                                _vm.result.market_research &&
                                _vm.result.market_research.length
                                  ? ""
                                  : "fade-in active show",
                              attrs: { role: "tabpanel", id: "exclusion" }
                            },
                            [
                              _c("h2", [_vm._v("Claims Exclusions info")]),
                              _vm._v(" "),
                              _c("h3", [
                                _vm._v("SBL will not accept any claims:")
                              ]),
                              _vm._v(" "),
                              _vm._m(6),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href:
                                      "/files/SBL_Claims_Policy_October_2022.pdf",
                                    target: "_blank"
                                  }
                                },
                                [_vm._v("View the full SBL claims policy here")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(7),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _vm.result.market_research &&
                          _vm.result.market_research.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "tab-pane fade fade-in active show",
                                  attrs: {
                                    role: "tabpanel",
                                    id: "market-research-tab"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-responsive",
                                      attrs: { id: "market-research" }
                                    },
                                    [
                                      _c("b-table", {
                                        staticClass: "bid-history table",
                                        attrs: {
                                          items: _vm.result.market_research,
                                          fields: _vm.marketSearchFields
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "cell(end_price)",
                                              fn: function(data) {
                                                return [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.numberWithCommas(
                                                          data.item.end_price
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          4263023284
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.result.co2_emissions && _vm.$userIsAdmin()
                            ? _c(
                                "div",
                                {
                                  staticClass: "tab-pane fade",
                                  attrs: { role: "tabpanel", id: "emissions" }
                                },
                                [
                                  _c("Co2DataTable", {
                                    attrs: {
                                      emissions: {
                                        data: _vm.result.co2_emissions
                                      }
                                    },
                                    on: {
                                      "row-click": function($event) {
                                        _vm.selectedEmission = $event
                                        _vm.showEmissionModal = true
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$userIsAdmin() && _vm.loggedInUser.id === 513
                      ? _c(
                          "a",
                          {
                            staticClass: "btn-link",
                            staticStyle: {
                              "margin-top": "15px",
                              display: "block"
                            },
                            attrs: { href: "#!" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.downloadLog.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Download Log")]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("EmissionModal", {
              attrs: {
                show: _vm.showEmissionModal,
                emission: _vm.selectedEmission
              },
              on: {
                close: function($event) {
                  _vm.showEmissionModal = false
                }
              }
            }),
            _vm._v(" "),
            _c("no-claims-modal", {
              attrs: {
                "is-open": _vm.noClaimsModalOpen,
                "no-claims-reason": _vm.result.no_claims_accepted
              },
              on: {
                close: _vm.closeNoClaimsModal,
                confirm: _vm.onConfirmNoClaimsBid
              }
            }),
            _vm._v(" "),
            _vm.vehicleLoaded
              ? _c("vehicle-recommendation-modal", {
                  attrs: {
                    notifyMessage: _vm.recommendMessageSendEmail,
                    vehicle_id: _vm.result.api_id,
                    recommend: true
                  },
                  model: {
                    value: _vm.recommendModalOpen,
                    callback: function($$v) {
                      _vm.recommendModalOpen = $$v
                    },
                    expression: "recommendModalOpen"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.vehicleLoaded
              ? _c("vehicle-recommendation-modal", {
                  attrs: {
                    notifyMessage: _vm.notifyMessageSendEmail,
                    vehicle_id: _vm.result.api_id
                  },
                  model: {
                    value: _vm.emailModalOpen,
                    callback: function($$v) {
                      _vm.emailModalOpen = $$v
                    },
                    expression: "emailModalOpen"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("change-bid", {
              ref: "changeBidModal",
              on: { changed: _vm.onBidChange }
            }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "topBidModel",
                attrs: { title: "Top Bid", "ok-title": "Send" },
                on: { ok: _vm.onTopBidOk }
              },
              [
                _c("p", [
                  _vm._v("\n                Hi"),
                  _vm.selectedBid &&
                  _vm.selectedBid.user &&
                  _vm.selectedBid.user.first_name
                    ? _c("span", [
                        _vm._v(" " + _vm._s(_vm.selectedBid.user.first_name))
                      ])
                    : _vm._e(),
                  _vm._v(
                    ",\n                to be top bidder within SBL your bid needs to be higher than "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.topBidText,
                        expression: "topBidText"
                      }
                    ],
                    ref: "topBidText",
                    attrs: { type: "text" },
                    domProps: { value: _vm.topBidText },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.topBidText = $event.target.value
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("bid-message", {
              ref: "bidMessage",
              on: { changed: _vm.onBidChange }
            }),
            _vm._v(" "),
            _c("staff-message", {
              ref: "staffMessage",
              on: { changed: _vm.onBidChange }
            }),
            _vm._v(" "),
            _vm.$userCan("fav_list")
              ? _c("favourite-tag-modal", {
                  attrs: { vehicleId: _vm.result.api_id },
                  on: { changed: _vm.onTagChanged },
                  model: {
                    value: _vm.favListModalOpen,
                    callback: function($$v) {
                      _vm.favListModalOpen = $$v
                    },
                    expression: "favListModalOpen"
                  }
                })
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pop-up-bid" }, [
      _c("strong", [_vm._v("Warning :")]),
      _vm._v(
        " Lorem ipsum dolor sit amet, consectetur\n                                        adipiscing\n                                        elit. Vestibulum at odio vel erat semper pretium.\n                                        "
      ),
      _c("button", { staticClass: "close-pop-up-bid" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "active",
          attrs: {
            "data-toggle": "tab",
            href: "#market-research-tab",
            role: "tab"
          }
        },
        [_vm._v("Market Research")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", {}, [
      _c(
        "a",
        { attrs: { "data-toggle": "tab", href: "#exclusion", role: "tab" } },
        [_vm._v("Claim Exclusions")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        {
          staticClass: "active",
          attrs: { "data-toggle": "tab", href: "#exclusion", role: "tab" }
        },
        [_vm._v("Claim Exclusions")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { "data-toggle": "tab", href: "#inspection", role: "tab" } },
        [_vm._v("Inspection Codes")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c(
        "a",
        { attrs: { "data-toggle": "tab", href: "#terms", role: "tab" } },
        [_vm._v("Terms & Conditions")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [_vm._v("for vehicles 10 years of age and over.")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("for vehicles which have travelled 100,000km or over.")
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("for vehicles which have an auction grade below 4.0.")]),
      _vm._v(" "),
      _c("li", [_vm._v("for issues notified to you at time of purchase.")]),
      _vm._v(" "),
      _c("li", [_vm._v("after a vehicle has been retailed or registered.")]),
      _vm._v(" "),
      _c("li", [_vm._v("for issues with a value of less than $600 + GST.")]),
      _vm._v(" "),
      _c("li", [_vm._v("successive claims for any vehicle.")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for any type of transmission issues in any make or model of vehicle."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for electrical and mechanical issues on all high performance vehicles ie Audi S3/S4/RS3/RS4/S5/RS5/S6/RS6/RS7/S8 BMW M3/M5/All 7 series, all Mercedes 63 variants, all Porsche variants, Jaguar F Types, and all Jaguar 5.0l petrol variants."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for any issues on BMW I3 or Smart Fourtwo or BMW 535i Active Hybrid."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for any issues relating to EV or Hybrid batteries for any make or model."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for air conditioning faults or failure in any make or model of vehicle."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for any stereo, infotainment or navigation faults or failure in any make or model of vehicle."
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("relating to spare keys missing mats or tono covers.")]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for airbag or air suspension or electric shocks in any make or model variant."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for Mazda product in Diesel in all make and model variants sub 2015."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("for electrical or mechanical faults in Mini variants sub 2015.")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("for electrical or mechanical faults in Volvo V40/V60 sub 2015.")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("for all VW and Audi product sub-2013 or pre facelift.")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for costs not directly relating to a claim (eg reconditioning or servicing)."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          'for any costs associated with "No TDN number" on export certificate.'
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("for modified vehicles.")]),
      _vm._v(" "),
      _c("li", [
        _vm._v("for warning lights on following a clear Astral Inspection.")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "for rust in any way, shape or form for Land Rover, and Range Rover vehicles"
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n                                            for known Manufacturers issues and faults as described below:\n                                            "
        ),
        _c("ul", [
          _c("li", [_vm._v("Toyota – seatbelts or Mark X shocks.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Nissan – Presage inner wheel arch rust – X-trail rust in rear suspension tower – March/Tida/Note rust in fire wall."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Mazda – MPV chassis rails – Demio rust around rear suspension – I Stop in any model – RX8 engine – 2.3 Turbo engines CX7/MPV/Axela and Atenza – CX5 Diesel KE2FW/KE2AW"
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Subaru – Forester seatbelts – Legacy Engine.")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("BMW – electronics – I Drive leaking oil – tappet noise.")
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("Audi – A8 electrical or mechanical issues.")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "tab-pane fade",
        attrs: { role: "tabpanel", id: "inspection" }
      },
      [
        _c("h2", [_vm._v("Inspection code info")]),
        _vm._v(" "),
        _c("h3", [_vm._v("Inspection Sheet Codes")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "The numbers 1,2,3 are used to qualify flaws and damage as approximately\n                                        minor, medium, or serious."
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("The following letters represent the type of flaw or damage.")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("A")]),
          _vm._v(" "),
          _c("span", [_vm._v("Scratch marks")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("B")]),
          _vm._v(" "),
          _c("span", [_vm._v("Bend/distortion or dent")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("BP")]),
          _vm._v(" "),
          _c("span", [_vm._v("Panel repair")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("C")]),
          _vm._v(" "),
          _c("span", [_vm._v("Corrosion or rust")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("E")]),
          _vm._v(" "),
          _c("span", [_vm._v("Dimples or dents")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("F")]),
          _vm._v(" "),
          _c("span", [_vm._v("Film/tinting on glass")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("G")]),
          _vm._v(" "),
          _c("span", [_vm._v("Chip in glass")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("H")]),
          _vm._v(" "),
          _c("span", [_vm._v("Hole")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("K")]),
          _vm._v(" "),
          _c("span", [_vm._v("Flaw")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("M")]),
          _vm._v(" "),
          _c("span", [_vm._v("Mark")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("P")]),
          _vm._v(" "),
          _c("span", [_vm._v("Paint damage")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("R")]),
          _vm._v(" "),
          _c("span", [_vm._v("Rust")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("R")]),
          _vm._v(" "),
          _c("span", [_vm._v("Repaired crack in glass")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("RX")]),
          _vm._v(" "),
          _c("span", [
            _vm._v("Repaired crack in glass that needs to be replaced")
          ])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("S")]),
          _vm._v(" "),
          _c("span", [_vm._v("Rust")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("T")]),
          _vm._v(" "),
          _c("span", [_vm._v("Temporary spare tyre")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("U")]),
          _vm._v(" "),
          _c("span", [_vm._v("Dents")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("W")]),
          _vm._v(" "),
          _c("span", [_vm._v("Wave in paint (Often caused by repair work)")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("X")]),
          _vm._v(" "),
          _c("span", [_vm._v("Damage")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("X")]),
          _vm._v(" "),
          _c("span", [_vm._v("Crack in glass")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("XX")]),
          _vm._v(" "),
          _c("span", [_vm._v("Body-part replaced")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("XXX")]),
          _vm._v(" "),
          _c("span", [_vm._v("Body-part replaced")])
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "inline-flex" }, [
          _c("span", [_vm._v("Y")]),
          _vm._v(" "),
          _c("span", [_vm._v("Crack or hole")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "tab-pane fade",
        attrs: { role: "tabpanel", id: "terms" }
      },
      [
        _c("ol", [
          _c("li", [
            _c("h3", [_vm._v("Claim Liability")]),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v(
                  "There are limitations on claims that can be made against SBL:\n                                                "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "SBL will not accept any mechanical claims for vehicles which\n                                                    have travelled 100,000km or over and/or which have an auction\n                                                    grade of 3.5 or below.\n                                                "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "SBL's claim liability on vehicles which have travelled between\n                                                    80,000 and 100,000km and which have an auction grade above 3.5\n                                                    is limited to the amount of the brokerage fee component of the\n                                                    price of the vehicle.\n                                                "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "A ramp check system is compulsory for all vehicles purchased.\n                                                    The purpose of the ramp check system is to eliminate whilst in\n                                                    Japan any major mechanical or paint and panel costs. Any\n                                                    vehicle arriving into NZ with excessive mechanical and/or paint\n                                                    and panel costs needs to be brought to the attention of SBL\n                                                    within 7 days of landing at your dealership. No work is to be\n                                                    carried out on the vehicle at all without first consulting with\n                                                    SBL either verbally or in writing.\n                                                "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "If the Purchaser makes any claim that a vehicle is defective or\n                                                    damaged, SBL may, at its discretion, repair the damage or defect\n                                                    or replace the vehicle or make a reasonable allowance on the\n                                                    purchase of a replacement vehicle if:\n                                                "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Without limiting SBL's ability to accept or decline claims, if\n                                                    the Purchaser does not comply with the above requirements, it\n                                                    will be deemed to have accepted . and SBL will not incur any\n                                                    liability whatsoever to the Purchaser in relation to the\n                                                    vehicle.\n                                                "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("a", { attrs: { href: "/files/SBLTerms.pdf", target: "_blank" } }, [
          _vm._v("Please view our full terms and conditions here")
        ])
      ]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46af5b69", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46af5b69","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SingleVehicle.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-46af5b69","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/SingleVehicle.vue
// module chunks = 0